var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    d: "M 0 249 L 0 234 C 26 232 59 216 59 216 C 232 144 300 224 360 250.7 C 420 277 480 235 540 234.7 C 600 235 660 277 720 293.3 C 780 309 840 301 901 275 C 966 245 1005 232 1057 215 C 1131 195 1182 191 1218 188 C 1291 185 1376 189 1440 195 L 1441 195 L 1440 320 L 1410 320 C 1380 320 1320 320 1260 320 C 1200 320 1140 320 1080 320 C 1020 320 960 320 900 320 C 840 320 780 320 720 320 C 660 320 600 320 540 320 C 480 320 420 320 360 320 C 300 320 240 320 180 320 C 120 320 60 320 30 320 L 0 320 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom1);
export default __webpack_public_path__ + "static/media/bottom1.06f1085a.svg";
export { ForwardRef as ReactComponent };